module.exports = __webpack_public_path__ + "static/media/earn-once-off-payment.bf306502.svg";